module.exports = __webpack_public_path__ + "img/no-team-activity-percentage.d59081af.webp";